// Application-level state connected to the browser's localStorage
// Required for the authentication state
import { createStore as reduxCreateStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import { APIGW_ROOT } from '../models/api';

const loadState = () => {
    try {
      const serializedState = localStorage.getItem('state');
      if (serializedState === null) {
        return undefined;
      }
      return JSON.parse(serializedState);
    } catch (err) {
      return undefined;
    }
  }; 

  const saveState = (state) => {
    try {
      const serializedState = JSON.stringify(state);
      localStorage.setItem('state', serializedState);
    } catch {
      // ignore write errors
    }
  };

const initialState = {
    isAuthenticated: false,
    user: '',
    accountEmail: '',
    accountID: '',
    accountKind: '',
    accessToken: '',
    refreshToken: '',
    isTokenRefreshing: false,
    sessionExpired: false
};

const reducer = (state, action) => {
    let stateInStorage = loadState();

    switch(action.type) {
        case 'LOG_IN': {
          let payload = action.payload.authState

          payload.sessionExpired = false;

          // Update localStorage
          saveState({ ...stateInStorage, ...payload });

          // Update app-level state
          return { ...state, ...payload };
        }
        case 'SET_ACCOUNT': {
          let payload = action.payload.accountState;

          // Update localStorage
          saveState({ ...stateInStorage, ...payload });

          // Update app-level state
          return { ...state, ...payload };
        }
        case 'LOG_OUT': {
          // Update localStorage 
          saveState({ ...stateInStorage, ...initialState });
          
          // Update app-level state
          return { isLogOut: true, ...state, ...initialState };
        }
        case 'LOG_OUT_SESSION_EXPIRED': {
          // Update localStorage 
          saveState({ ...stateInStorage, ...initialState });

          // Update app-level state
          return { ...state, ...initialState, ...{sessionExpired: true} };
        }
        case 'REFRESH_TOKEN_START': {
          let payload = {
            isTokenRefreshing: true
          }

          return { ...state, ...payload };
        }
        case 'REFRESH_TOKEN_FINISH': {
          let payload = {
            isTokenRefreshing: false
          }

          return { ...state, ...payload };
        }
        case 'REFRESH_TOKEN': {
          // Update localStorage 
          let payload = action.payload

          saveState({ ...stateInStorage, ...payload });

          // Update app-level state
          return { ...state, ...payload };
        }
        default:
            return state;
    }
}


let loadedState = loadState();

const initialStateWithLocal = {...initialState, ...loadedState }

export const refreshToken = () => async (dispatch, getState) => {
  try {
    let state = getState();
    let refreshToken = state.refreshToken;
    let payload = JSON.stringify({token: refreshToken});

    dispatch({type: 'REFRESH_TOKEN_START'});
    
    const res = await fetch(`${APIGW_ROOT}users/refresh`, {method: 'POST', body: payload }).then(res => res.json());

    if (!res.token) throw new Error('Session expired');

    dispatch({type: 'REFRESH_TOKEN', payload: { accessToken: res.token }})
    console.log({ res })

    dispatch({type: 'REFRESH_TOKEN_FINISH'});

    return res.token
  } catch (err) {
    console.log(err);
    dispatch({type: 'REFRESH_TOKEN_FINISH'});
    dispatch({type: 'LOG_OUT_SESSION_EXPIRED'});
  }
}

const createStore = () => reduxCreateStore(reducer, initialStateWithLocal, applyMiddleware(thunk));

export default createStore;
